export default __webpack_public_path__ + "static/media/star.f4d8b123.png";